module.exports = __webpack_public_path__ + "static/media/buzzer-small2.e19ac5d5.aac";